// extracted by mini-css-extract-plugin
module.exports = {"Video":"RecordingPlayer-Video-2_04aS","Audio":"RecordingPlayer-Audio-3wn2C3","AudioArtwork":"RecordingPlayer-AudioArtwork-3zJchl","Button":"RecordingPlayer-Button-30qKS6"};